/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>促销活动列表
      <div slot="right" class="ml-auto">
        <el-button size="small" type="success" @click="addEditDiscount">添加促销</el-button>
        <span class="text-link ml-5 h6" v-show="isGroup" @click="$router.back()">返回列表</span>
      </div>
    </public-title>
    <div class="load-area">
      <p v-if="StoreDiscountLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in StoreDiscountLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col">{{Itemize.title}}</li>
          <li class="w-50 list-item-col">{{Itemize.startdate | formatTimestamp}}</li>
          <li class="w-50 list-item-col">{{Itemize.enddate | formatTimestamp}}</li>
          <li class="w-50 list-item-col" :class="Itemize.status ? 'text-success' : 'text-danger'">
            {{Itemize.status? '已发布' : '审核中'}}
          </li>
          <li class="w-50 list-item-col-end">
            <span class="text-link mr-2" @click="addEditDiscount(Itemize)">编辑</span>
            <span class="text-link" @click="deleteDiscount(Itemize)">删除</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                      :total="StoreDiscountLists.total" :current-page="Number(queryCon.page)"
                      @current-change="v => this.currentPage=v"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState,mapMutations } from 'vuex'

  export default {
    name: 'StoreDiscountLists',
    computed: {
      ...mapState(['StoreDiscountLists']),
      ...mapGetters(['storeInfo','isGroup']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getStoreDiscountLists({...this.queryCon,page:this.currentPage}); },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:['标题','开始时间','结束时间','状态','操作'],
        currentPage:1,
      }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store})
      this.getStoreDiscountLists({page:this.currentPage});
    },
    beforeDestroy() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreDiscountLists','deleteStoreDiscount']),
      //添加、编辑促销活动
      addEditDiscount(item) {
        if (!this.$GFUN.powerIsInArray([196,198])) { this._alert('您没有相关权限！',null,'error'); return; }
        let query = {store:this.$route.query.store,GST:this.$route.query.GST};
        if (item) query.discount = item.id;
        this.$router.push({name:'addEditDiscount',query})
      },
      //删除促销活动
      deleteDiscount(item) {
        if (!this.$GFUN.powerIsInArray([199])) { this._alert('您没有相关权限！',null,'error'); return; }
        this._confirm('确认删除么？',() => { this.deleteStoreDiscount(item.id) });
      },
    },
  }
</script>
